const dueDateActions = {
  'DUE-DATE': 'dueDate',
  REMINDER: 'reminder',
  REPEAT: 'repeat'
}

const reminderActions = {
  DEFINEDOPTIONS: 'task_reminder_defined_options',
  CUSTOM: 'task_reminder_cutom_option'
}

const reminderOptions = [
  {
    message: 'task_reminder_1_hr_option',
    alert: {
      quantity: 1,
      unit: 'Hours'
    }
  },
  {
    message: 'task_reminder_3_hr_option',
    alert: {
      quantity: 3,
      unit: 'Hours'
    }
  },
  {
    message: 'task_reminder_1_day_option',
    alert: {
      quantity: 1,
      unit: 'Days'
    }
  },
  {
    message: 'task_reminder_3_day_option',
    alert: {
      quantity: 3,
      unit: 'Days'
    }
  },
  {
    message: 'task_reminder_1_week_option',
    alert: {
      quantity: 3,
      unit: 'Weeks'
    }
  },
  { message: 'task_reminder_cutom_option' }
]

const repeatOptions = [
  {
    message: 'task_repeat_none_option',
    repeater: ''
  },
  {
    message: 'task_repeat_every_week_option',
    repeater: 'FREQ=WEEKLY;INTERVAL=1'
  },
  {
    message: 'task_repeat_every_2_weeks_option',
    repeater: 'FREQ=WEEKLY;INTERVAL=2'
  },
  {
    message: 'task_repeat_every_month_option',
    repeater: 'FREQ=MONTHLY;INTERVAL=1'
  },
  {
    message: 'task_repeat_every_3_months_option',
    repeater: 'FREQ=MONTHLY;INTERVAL=3'
  },
  {
    message: 'task_repeat_every_year_option',
    repeater: 'FREQ=YEARLY;INTERVAL=1'
  }
]

const userTypeOptions = {
  USER: 'User',
  'TEAM-GROUP': 'TeamGroup',
  CONTACT: 'Contact'
}

const segmentedAssigneeTabOptions = {
  MEMBERS: 'members',
  TEAMS: 'teams',
  CONTACTS: 'contacts'
}

const fileUploadState = {
  'NEW-UPLOAD': 'new_upload',
  UPLOADED: 'uploaded'
}

const roleTypes = {
  'POWER-USER': 'PowerUser',
  ASSISTANT: 'Assistant',
  VIEWER: 'Viewer',
  'EXTERNAL-VISITOR': 'ExternalVisitor',
  SUBCONTRACTOR: 'SubContractor'
}

const badgesColorByRole = {
  [roleTypes['POWER-USER']]: 'violet',
  [roleTypes.ASSISTANT]: 'blue',
  [roleTypes.VIEWER]: 'green',
  [roleTypes['EXTERNAL-VISITOR']]: 'turquoise',
  [roleTypes.SUBCONTRACTOR]: 'ochre'
}

const roleTranslation = {
  [roleTypes['POWER-USER']]: 'personas_roleLabelPowerUser',
  [roleTypes.ASSISTANT]: 'personas_roleLabelAssistant',
  [roleTypes.VIEWER]: 'personas_roleLabelViewer',
  [roleTypes['EXTERNAL-VISITOR']]: 'personas_roleLabelExternalVisitor',
  [roleTypes.SUBCONTRACTOR]: 'personas_roleLabelSubContractor'
}

const userStatusOptions = {
  INVITED: 'Invited',
  REMOVED: 'Removed',
  ACTIVE: 'Active',
  INACTIVE: 'Inactive'
}
const handleDeactivateCommentsOptions = {
  REACTIVATING: 'reactivating',
  DEACTIVATING: 'deactivating'
}

export {
  dueDateActions,
  reminderActions,
  reminderOptions,
  repeatOptions,
  userTypeOptions,
  segmentedAssigneeTabOptions,
  fileUploadState,
  badgesColorByRole,
  roleTranslation,
  userStatusOptions,
  handleDeactivateCommentsOptions
}
